<template>
  <section class="text-area-inputs">
    <section-title>TextAreaInput Component</section-title>
    <form-wrap>
      <form-field-set>
        <text-area-input
          v-model="textAreaInput"
          :direction="direction"
          label="Text Input"
          name="textAreaInput1"
        />

        <text-area-input
          v-model="textAreaInput"
          :direction="direction"
          :is-disabled="true"
          label="Text Input Disabled"
          name="textAreaInput2"
        />

        <text-area-input
          :direction="direction"
          label="Text Input Placeholder"
          placeholder="This is a placeholder"
          name="textAreaInputPlaceholder"
          value=""
        />

        <text-area-input
          v-model="textAreaInput"
          :direction="direction"
          error="Räum dein Zimmer auf"
          label="Text Input Error"
          name="textAreaInput3"
        />
      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import PlaygroundCommmonMixin from '@/mixins/pages/playground/PlaygroundCommon'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import SectionTitle from '@/components/ui/SectionTitle'
import TextAreaInput from '@/components/forms/TextAreaInput'

export default {
  name: 'TextAreaInputs',
  mixins: [PlaygroundCommmonMixin],
  components: {
    FormFieldSet,
    FormWrap,
    SectionTitle,
    TextAreaInput
  },
  data () {
    return {
      textAreaInput: `Agnes von Poitou oder Kaiserin Agnes (* um 1025; † 14. Dezember 1077 in Rom) war nach dem Tod ihres Mannes Kaiser Hein­rich III. wäh­rend der Minder­jährig­keit ihres Sohnes Heinrich IV. von 1056 bis 1061 Re­gentin des römisch-deut­schen Reiches. 1061 zog sie sich nach einem von ihr mit­verschul­deten Papst­schisma aus der Re­gierungs­verant­wortung zurück, sicherte aber weiter­hin die Thron­ansprüche ihres Sohnes. Agnes von Poitou, Tochter Her­zog Wilhelms von Aqui­tanien und Poitou und seiner Frau Agnes von Bur­gund, wurde im Jahre 1043 in Mainz zur deut­schen Kö­nigin ge­krönt und am 21. Novem­ber des glei­chen Jah­res in Ingel­heim mit Heinrich III. ver­mählt. Die Kaiser­krönung beider fand am 25. De­zember 1046 in Rom statt. Hein­rich hatte Agnes zu seiner Ge­mahlin er­wählt, nach­dem seine erste Frau Gun­hild der Mala­ria zum Opfer ge­fallen war. Die Ver­mählung mit Agnes hatte für ihn hauptsächlich macht­politische Vor­teile. So ver­stärkte die Ver­bindung mit einem der mäch­tigsten franzö­sischen Fürsten­häuser den Druck auf das franzö­sische Königs­haus und war geeig­net, Hein­richs Posi­tion in Bur­gund zu ver­bessern, da Agnes’ Familie dort reich begü­tert war. Agnes war eine gebil­dete und von tie­fer Frömmig­keit er­füllte junge Frau.`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/TextAreaInputs.vue